import React, { Component } from "react";
import scrollToComponent from "react-scroll-to-component";

class Block extends Component {
  constructor(props) {
    super(props);
    this.observer = props.observer;
    this.myRef = React.createRef();
  }

  render() {
    //console.log("content", this.props.item.content);
    return (
      <div className="topic" ref={this.myRef}>
        <h3 id={this.props.item.title}>{this.props.item.title}</h3>
        <ul>
          {this.props.item.content != null ? this.props.item.content : <div />}
        </ul>
      </div>
    );
  }

  componentDidMount() {
    //console.log("subscribe scroll");
    this.observer.subscribe("scroll", id => {
      //console.log("scroll ID is: " + id);
      if (this.props.item.id === id) {
        // console.log(
        //   "scroll to " + this.props.item.title + " (" + this.props.item.id + ")"
        // );
        scrollToComponent(this.myRef.current, {
          align: "top",
          duration: 1000
        });
      }
    });
  }

  componentWillUnmount() {
    this.observer.unsubscribe("scroll");
  }
}

export default Block;
